import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'debitur';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(baseurl, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 
                'custinfo', 'nomoridentitas', 'npwp', 'PhoneNo', 
                'alamatktp', 'City', 'collector_name', 'modified',
                'CustCode','CustName','alamtktp'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    exportxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exportxls/${str}`;
                //console.log('#obj exportxls: ',obj);
                //console.log('#str exportxls: ',str);
                //console.log('#url exportxls: ',url);
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    console.log("#response: ", response);
                    console.log("#response.data: ", response.data);
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'masterdebitur.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    exporthistoryxls(obj = {}) {
        return new Promise((resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'tgl1', 'tgl2'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/exporthistoryxls/${str}`;
                axios({
                    url: url,
                    method: 'GET',
                    responseType: 'blob', // important
                }).then((response) => {
                    //console.log("#response: ", response);
                    console.log("#response.data: ", response.data);
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'historycollector.xlsx');
                    document.body.appendChild(link);
                    link.click();
                    // window.location.assign(url);
                    resolve(link);
                });

            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    detail(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    historycollection(nasabahkey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/historycollection/${nasabahkey}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    collectorasignhistorydelete(collasignkey){
        return new Promise(async (resolve, reject) => {
            try {
                console.log('#collasignkey: ',collasignkey);
                await axios.post(`${baseurl}/historycollectiondelete`,{collasignkey});
                resolve(true);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    importdtxls(filexls, obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const fd = new FormData();
                fd.append('fileXlsx', filexls, filexls.name);
                // const keys = ['sheetName', 'startRow', 'invoiceno', 'CustCode', 'CustName', 'Address1', 'npwp','npwp_name'];
                for (const key in obj) {
                    // if (keys.indexOf(key) >= 0 && obj[key]) {
                    fd.append(key, obj[key]);
                    // }
                }
                const { data } = await axios.post(`${baseurl}/uploadcoltodb`, fd);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    savebulk(arr) {
        return new Promise(async (resolve, reject) => {
            try {
                await axios.post(`${baseurl}/savebulk`, arr);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    // detail(obj){
    //     return new Promise(async (resolve, reject) => {
    //         try {
    //             const keys = ['nasabahkey'];
    //             let str = '';
    //             for (const key in obj) {
    //                 if (keys.indexOf(key) >= 0 && obj[key]) {
    //                     str += str ? '&' : '?';
    //                     str += key + '=' + encodeURIComponent(obj[key]);
    //                 }
    //             }
    //             const url = `/${baseurl}${str}`
    //             const {data} = await axios.get(url);
    //             resolve(data);
    //         } catch (error) {
    //             errorHandler(error, reject)
    //         }
    //     })
    // }
    collectorasignhistory(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = [
                    'page',
                    'limit',
                    'total',
                    'nasabahkey',
                    'sortBy',
                    'sortDesc',
                    'sortDir'
                ];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const { data } = await axios.get(`${baseurl}/collector-assignment-history${str}`);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },

    collectorassignment(obj){
        return new Promise(async (resolve, reject) => {
            try {
                console.log('obj',obj);
                await axios.post(`${baseurl}/collector-assignment`, obj);
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    }

}